var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 17H18C14.134 17 11 13.866 11 10C11 6.134 14.134 3 18 3H26V17Z",
    fill: "url(#paint0_linear_398_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31H18C14.134 31 11 27.866 11 24C11 20.134 14.134 17 18 17H25V31Z",
    fill: "url(#paint1_linear_398_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 45C14.134 45 11 41.866 11 38C11 34.134 14.134 31 18 31H25V38C25 41.866 21.866 45 18 45Z",
    fill: "url(#paint2_linear_398_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17H25V3H32C35.866 3 39 6.134 39 10C39 13.866 35.866 17 32 17Z",
    fill: "url(#paint3_linear_398_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31C35.866 31 39 27.866 39 24C39 20.134 35.866 17 32 17C28.134 17 25 20.134 25 24C25 27.866 28.134 31 32 31Z",
    fill: "url(#paint4_linear_398_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_2",
    x1: 16.309,
    y1: 1.101,
    x2: 23.023,
    y2: 19.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_398_2",
    x1: 15.64,
    y1: 14.636,
    x2: 22.314,
    y2: 32.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE4CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9331BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_398_2",
    x1: 14.81,
    y1: 26.357,
    x2: 21.821,
    y2: 45.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_398_2",
    x1: 27.498,
    y1: 0.512,
    x2: 34.119,
    y2: 18.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_398_2",
    x1: 28.714,
    y1: 14.972,
    x2: 34.857,
    y2: 31.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32BDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EA2E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.3b61e3aa1eba9db891eccad558020020.svg";
export { ForwardRef as ReactComponent };